import { Badge, ListGroup, ListGroupItem } from "reactstrap";
import { CoordinatorCustomer } from "../types/PrivateChat";

interface Props {

    customers: CoordinatorCustomer[];

    selectedConversation?: string;

    onSelect: (
        customer: CoordinatorCustomer
    ) => void;
}

const CoordinatorCustomerList = ({
    customers,
    selectedConversation,
    onSelect
}: Props) => {

    return (

        <ListGroup flush >

            {

                customers.map(customer => (

                    <ListGroupItem

                        key={customer.conversationId}

                        action

                        active={
                            customer.conversationId ===
                            selectedConversation
                        }

                        onClick={() =>
                            onSelect(customer)
                        }

                    >

                        <div className="d-flex justify-content-between">

                            <div>

                                {customer.userName}

                            </div>

                            {

                                customer.unreadCount > 0 && (

                                    <Badge color="primary">

                                        {customer.unreadCount}

                                    </Badge>

                                )

                            }

                        </div>

                    </ListGroupItem>

                ))

            }

        </ListGroup>

    );
};

export default CoordinatorCustomerList;